// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__fJxtr","error":"Textarea_error__2zJyM","readonly":"Textarea_readonly__3FHxp","disabled":"Textarea_disabled__2C5Y-"};